import { route } from 'quasar/wrappers';
// import storage from "../services/storage"
import h from '../services/helpers'
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory);

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(
      process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  });

  // Router.replace({ path: '*', redirect: '/' })

  Router.beforeEach((to, from, next) => {

     // console.log("beforeEach",to)

     if (to.matched.some(record => record.meta.requiresPromoterAuth)) {

      if (!h.promoterIsLoggedIn()) {
        next({ name: 'PromoterLogin' })
        return;
      } 
      next() // go to wherever I'm going
      
    }else if (to.matched.some(record => record.meta.requiresAuth)) {

          if (!h.isLoggedIn() ) {
            next({ name: 'Login' })
            return;
          } 
          next() // go to wherever I'm going
    }else if (to.matched.some(record => record.meta.requiresKundeAuth)) {
      console.log("dsdssd",h.kundeIsLoggedIn())
      if (!h.kundeIsLoggedIn() ) {
        next({ name: 'KundenLogin' })
        return;
      } 
      next() // go to wherever I'm going
      
     } else {
          next() // does not require auth, make sure to always call next()!
     }




})


  return Router;
});
